export const scrollToTop = (timeout = 0) =>
  setTimeout(() => window.scrollTo({ left: 0, top: 0, behavior: 'smooth' }), timeout);
